import * as React from "react";
import { Link } from "gatsby";
import Seo from "../components/seo";
import ClientsTestimonial from "../components/clients-testimonial";
import Awards from "../components/awards";
import OurClients from "../components/our-clients";
import CaseStudy from "../components/case-study";
import BlogList from "../components/blog/blog-list";
import BannerForm from "../components/banner-form";
import { Container, Row, Col, } from "react-bootstrap";
import { TopMobileAppDevelopmentCompanyUSAMeta } from "../data/metaData";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../components/layout/layout";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import Scrollspy from "react-scrollspy";

import bannerImage from "../images/top-mobile-app-usa-banner.jpg";

export const Head = () => (
  <Seo
    title={TopMobileAppDevelopmentCompanyUSAMeta.metaTitle}
    description={TopMobileAppDevelopmentCompanyUSAMeta.metaDescription}
    ogImage={TopMobileAppDevelopmentCompanyUSAMeta.ogImage}
    twitterImage={TopMobileAppDevelopmentCompanyUSAMeta.twitterImage}
  />
)

const TopMobileAppDevelopmentCompanyUSAPage = () => {

  const Startups = '../images/top-mobile-app-usa-startup-app-for-nurse-alert.png'
  const SMEs = '../images/top-mobile-app-usa-sme-app-for-m2r.png'
  const Enterprise = '../images/top-mobile-app-usa-enterprise-app-nazah.png'

  const ThreeTab = [
    {
      tabId: "tab1",
      name: "Startups",
      title: "Mobile app <span class='text-primary'>startup</span>",
      smallTitle: "An idea of startup or an enterprise going mobile, we serve both ways",
      desc: "Behind every successful tech-enabled startup, there is a silent hero who plays a significant role. The assistance of the best app development company in the US to tailor a startup mobility solution. Gauging the need of today’s startups, we prove our expertise in delivering iOS and Android mobile app development. Write your Startup Growth Story, With us!",
      keyname: "ThreeTabImg1"
    },
    {
      tabId: "tab2",
      name: "SMEs",
      title: "Mobile apps for <span class='text-primary'>SMEs</span>",
      smallTitle: "Leading firms in the US rely on our development services to make relevance in the mobile world",
      desc: "Small businesses require scalable solutions for writing their growth story. We aim to deliver successful mobile app solutions to our client in the US for ultimate scalability of SMEs and bootstrapped startups. Our expertise lies in focusing on SME’s mobile app development for Project Management System, which in turn guarantees productivity, efficiency, and robustness.",
      keyname: "ThreeTabImg2"
    },
    {
      tabId: "tab3",
      name: "Enterprise",
      title: "<span class='text-primary'>Enterprise</span> mobility solutions",
      smallTitle: "A sneak peek into how we approach app development and stand tall despite of challenges",
      desc: "Enhancing business through successful implementations of mobile app development solution is the way of evolving an enterprise further. We provide best mobility solutions to capture minute details of your business ecosystem, but on mobile.",
      keyname: "ThreeTabImg3"
    }
  ]
  const ServicesThatYou = [
    {
      iconName: "mobile-app",
      title: "Mobile app",
      desc: "Apps assist to engage customers in an efficient way which results in exponential growth of your business.",
      list: [
        {
          text: "iOS",
          link: "/ios-application-development.html"
        },
        {
          text: "Android",
          link: "/android-application-development.html"
        },
        {
          text: "UI/UX Design",
          link: "/ui-ux-design.html"
        }
      ],
      boxLink: "/mobile-application-development.html"
    },
    {
      iconName: "web-development",
      title: "Web Development",
      desc: "Web development is an essential component which plays a significant role in increasing sales by attracting more customers.",
      list: [
        {
          text: "Python",
          link: "/python-development.html"
        },
        {
          text: "PHP",
          link: "/php-web-development.html"
        },
        {
          text: "Laravel",
          link: "/hire-laravel-developer.html"
        }
      ],
      boxLink: "/web-application-development.html"
    },
    {
      iconName: "cognitive-technology",
      title: "Cognitive Technology",
      desc: "Our developers are well experienced in integrating cognitive technologies such as AI & Machine learning.",
      list: [
        {
          text: "Internet of Things (IoT)",
          link: "/internet-of-things-iot-applications-development-company.html"
        },
        {
          text: "Bot Development",
        },
        {
          text: "Wearable App",
          link: "/wearable-app-development.html"
        }
      ],
      boxLink: "/internet-of-things-iot-applications-development-company.html"
    }
  ]
  const SeveralIndustry = [
    {
      link: "/healthcare-software-development.html",
      iconName: "healthcare",
      title: "Healthcare"
    },
    {
      link: "/logistics-software-development.html",
      iconName: "logistics",
      title: "Logistics"
    },
    {
      iconName: "education",
      title: "Education"
    },
    {
      link: "/retail-mobility-solutions.html",
      iconName: "retail",
      title: "Retail"
    },
    {
      link: "/financial-software-development.html",
      iconName: "finance",
      title: "Finance"
    },
    {
      link: "/wellness-and-fitness-app-development.html",
      iconName: "wellness-fitness",
      title: "Wellness & fitness"
    },
    {
      link: "/oil-and-gas-industry-app-solution.html",
      iconName: "oil-gas",
      title: "Oil & Gas"
    },
    {
      link: "/logistics-software-development.html",
      iconName: "logistics",
      title: "Transportation"
    },
    {
      iconName: "travel",
      title: "Travel"
    },
    {
      iconName: "social-network",
      title: "Social Network"
    },
    {
      iconName: "event",
      title: "Event"
    },
    {
      iconName: "productivity",
      title: "Productivity"
    },
  ]

  const EngagementModels = [
    {
      iconName: "fixed-budget",
      title: "Fixed Budget",
      desc: "This method includes fixed budget and we ensure to follow strict standards throughout the period.",
      list: [
        {
          text: "Pay for quality not quantity",
        },
        {
          text: "Pricing based on requirement",
        },
        {
          text: "No Hidden Cost",
        },
        {
          text: "High working standards",
        }
      ]
    },
    {
      iconName: "time-material",
      title: "Time & Material",
      desc: "In this method there is no fixed Time & Budget. You pay only for the hours taken by us to complete the task.",
      list: [
        {
          text: "Value for your time"
        },
        {
          text: "Discuss and understand"
        },
        {
          text: "Pay per hour"
        },
        {
          text: "Get Regular Updates"
        }
      ]
    },
    {
      iconName: "cloud-team",
      title: "Cloud Team",
      desc: "This is the most flexible method as you have a whole dedicated team. This allows you to make real-time changes.",
      list: [
        {
          text: "Personalized Team"
        },
        {
          text: "No Deadline",
        },
        {
          text: "Real-time Updates"
        },
        {
          text: "Cost Effective"
        }
      ]
    }
  ]

  return (

    <>
      <Layout headerClass="navbar-dark">
        <section className="section banner-image" style={{ backgroundImage: `url(${bannerImage})` }}>
          <Container className="py-5 mt-lg-5">
            <Row className="align-items-center g-5">
              <Col lg={6}>
                <h1 className="mb-4 text-white">
                  Mobile development in the US that services your <span className="text-primary">business purpose</span>
                </h1>
                <p className="lead mb-0 text-white-75">
                  Writing thousands of app codes has helped us gain expertise over it. As one of the top app development companies in the US, we blend our knowledge and skill to deliver world class mobile application development services. Our arsenal of skilled mobile app developers excels with confidence and are responsible for thousands of mobile apps.
                </p>
              </Col>
              <Col lg={6}>
                <BannerForm />
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section ">
          <Container className="pt-5">
            <div className="mb-5 pb-1 text-center">
              <h2 className="mb-4 text-center">
                Mobile app development <br /><span className="text-primary">company with office</span> in Addison, Texas
              </h2>
              <p className="max-width-950 lead mx-auto">Our work has placed us among the top mobile app development companies in the USA. With our wide range of world-class enterprise mobility solutions, we are expert in providing best mobile app development services to write the success story of your business.</p>
              <p className="max-width-950 lead mb-0 mx-auto">When the experience of our mobile app developers blends with the creative art of developing a mobile application, we thrive to provide your business with the best mobile experience. Because the onus of your success lies in our credibility to deliver top-notch mobile app solutions.</p>
            </div>
          </Container>
        </section>
        <section className="section bg-light">
          <div className="engagement-tab-fixed bg-light py-3">
            <Container>
              <Scrollspy offset={-152} className="list-unstyled d-flex align-items-center engagement-tab mb-0" items={['tab1', 'tab2', 'tab3']} currentClassName="active">
                {ThreeTab?.map((item, index) => (
                  <li key={index} className={index === 0 ? "active" : ""}>
                    <AnchorLink to={`/top-mobile-app-development-company-usa.html#${item.id}`} stripHash className="nav-link stripped">
                      {item.name}
                    </AnchorLink>
                  </li>
                ))}
              </Scrollspy>
            </Container>
          </div>
          {ThreeTab?.map((item, index) => (
            <div key={index} id={item.tabId}>
              <Container className="py-5">
                <Row className="align-items-center g-4" xs={1} md={1} lg={2}>
                  <Col className={`${index % 2 === 0 ? '' : 'order-lg-2'}`}>
                    <h2 className="mb-4" dangerouslySetInnerHTML={{ __html: item.title }} />
                    <h3 className="text-primary h4 mb-4">{item.smallTitle}</h3>
                    <p className="font-size-18">{item.desc}</p>
                  </Col>
                  <Col className="text-center">
                    {item.keyname === "ThreeTabImg1" ?
                      <StaticImage loading="lazy" src={Startups} alt="Startup app nurse alert" width={649} height={573} />
                      : null
                    }
                    {item.keyname === "ThreeTabImg2" ?
                      <StaticImage loading="lazy" src={SMEs} alt="sme app m2r" width={649} height={573} />
                      : null
                    }
                    {item.keyname === "ThreeTabImg3" ?
                      <StaticImage loading="lazy" src={Enterprise} alt="Enterprise app nazah" width={649} height={573} />
                      : null
                    }
                  </Col>
                </Row>
              </Container>
            </div>
          ))}

        </section>
        <section className="section ">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Services that You <span className="text-primary">Can’t Deny</span>
              </h2>
              <p className="max-width-950 lead">With the constant endeavors to avail your businesses with the fantastic mobile app development service, we raise our benchmark to stand by the title of being few of the best mobile app development companies in Texas, USA.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={3}>
              {ServicesThatYou?.map((item, index) => (
                <Col key={index}>
                  <div className="dark-box-1 left-icon-box equal-height">
                    <i className={`top-mobile-app-usa-sprite icon-size-85 mb-4 ${item.iconName}`}></i>
                    <h3 className="h4 mb-3">{item.title}</h3>
                    <p className="">{item.desc}</p>
                    <ul className="bullet-list">
                      {item.list?.map((item, index) => (
                        <li key={index}>
                          {item.link ?
                            <Link to={item.link} className="text-body force-hover d-inline-block">{item.text}</Link>
                            : <>{item.text}</>
                          }
                        </li>
                      ))}
                    </ul>
                    <Link to={item.boxLink} className="btn btn-link px-0 mt-3">
                      <span>Learn More</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                    </Link>

                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <section className="section bg-light">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                Mobile App Development <br /><span className="text-muted">for</span> <span className="text-primary">Several Industry</span> <span className="text-muted">Verticals</span>
              </h2>
              <p className="max-width-950 lead">Our developers are well experienced in developing numerous apps for various industry verticals.</p>
            </div>
            <Row as="ul" xs={1} sm={2} lg={3} className="list-unstyled g-4">
              {SeveralIndustry?.map((item, index) => (
                <Col key={index} as="li">
                  {item.link ?
                    <Link to={item.link} className="dark-box-2 d-flex align-items-center p-3 rounded-3">
                      <i className={`mobile-application-sprite-icon icon-size-70 me-3 ${item.iconName}`}></i>
                      <h3 className="h4 fw-normal mb-0 text-body force-hover">{item.title}</h3>
                    </Link> :
                    <div className="dark-box-2 d-flex align-items-center p-3 rounded-3">
                      <i className={`mobile-application-sprite-icon icon-size-70 me-3 ${item.iconName}`}></i>
                      <h3 className="h4 fw-normal mb-0 text-body">{item.title}</h3>
                    </div>
                  }
                </Col>
              ))}

            </Row>
          </Container>
        </section>
        <section className="section">
          <Container className="py-5">
            <div className="mb-5 pb-1">
              <h2 className="mb-4">
                <span className="text-primary">Engagement</span> Models
              </h2>
              <p className="max-width-950 lead">We deal with different types of businesses each having a distinct demand. We meet these demands by offering multiple engagement models.</p>
            </div>
            <Row className="g-4" xs={1} md={2} lg={3}>
              {EngagementModels?.map((item, index) => (
                <Col key={index}>
                  <div className="dark-box-1 left-icon-box equal-height">
                    <i className={`top-mobile-app-usa-sprite icon-size-85 mb-4 ${item.iconName}`}></i>
                    <h3 className="h4 mb-3">{item.title}</h3>
                    <p className="">{item.desc}</p>
                    <ul className="bullet-list">
                      {item.list?.map((item, index) => (
                        <li key={index}>{item.text}</li>
                      ))}
                    </ul>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <section className="section bg-black">
          <Container className="py-5">
            <div className="text-center py-lg-5">
              <h2 className="mb-4 text-white">
                Work With <span className="text-primary">Top-Notch</span> Mobile App Developers
              </h2>
              <Link to="/request-quote.html" className="btn btn-lg btn-primary-theme-outline mt-4">
                Request a callback
              </Link>
            </div>
          </Container>
        </section>
        <ClientsTestimonial />
        <Awards />
        <OurClients />
        <CaseStudy
          title="Fill in your detail for a free <span class='text-primary'>one-to-one</span> <br />Skype consultation session with our app specialist"
          description="How we understand? How we create? How we present? And how we manage? Everything that will prove the way we create the new definitions of understanding and perfection everytime we work."
        />
        <BlogList
          description="Get yourself updated by reading our authentic insights and expert opinions on the latest technology trends and news via our well-crafted articles, write-ups, and blogs."
        />
      </Layout>
    </>
  );
};

export default TopMobileAppDevelopmentCompanyUSAPage;
